import React from 'react';
import { Navigate } from 'react-router-dom';

// Lazy load components
const Pledges = React.lazy(() => import('../pages/Pledges/Pledges'));
const NewPledge = React.lazy(() => import('../pages/Pledges/NewPledge'));
const PledgeDetail = React.lazy(() => import('../pages/Pledges/PledgeDetail'));
const RecurringPledges = React.lazy(() => import('../pages/Pledges/RecurringPledges/RecurringPledges'));
const RecurringPledgeDetail = React.lazy(() => import('../pages/Pledges/RecurringPledges/RecurringPledgeDetail'));

export const getPledgeRoutes = (loggedIn, visibleTabs, location, loginRedirect) => [
  {
    path: '/pledges-list',
    element: (loggedIn && visibleTabs?.includes('Pledges'))
      ? <Pledges />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'new-pledge',
        element: (loggedIn && visibleTabs?.includes('Pledges'))
          ? <NewPledge />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'pledge-details',
        element: (loggedIn && visibleTabs?.includes('Pledges'))
          ? <PledgeDetail />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  },
  {
    path: '/rec-pledges-list',
    element: (loggedIn && visibleTabs?.includes('Pledges_Reccuring'))
      ? <RecurringPledges />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'new-pledge',
        element: (loggedIn && visibleTabs?.includes('Pledges_Reccuring'))
          ? <NewPledge />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'pledge-details',
        element: (loggedIn && visibleTabs?.includes('Pledges_Reccuring'))
          ? <RecurringPledgeDetail />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  }
];

